<iss-icon
  class="iss-circle-button-icon"
  [name]="name"
  [tuiHint]="tooltip"
  [tuiHintDirection]="'bottom'"
/>
